import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import "./assets/css/base.css";

// ★ createRoot (React 18) แทน ReactDOM.render ที่เป็นโหมด legacy — ได้ automatic batching
//   และไม่มีคำเตือน deprecated ใน console
// ★ วงหมุนตอนโหลดอยู่ใน public/index.html (#loading) ไม่ได้ render จากที่นี่แล้ว
createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);
